<template>
  <div>
    <component :is="currentPortal"/>
  </div>
</template>

<script>
import Approvals from '@/views/components/portals/Approvals.vue';
import Nominations from '@/views/components/portals/awards/NominationsEditPortal.vue';
import ReportsEditPortal from '@/views/components/portals/awards/ReportsEditPortal.vue';

export default {
  name: 'PortalContent',
  components: {
    Approvals,
  },
  data() {
    return {
      portals: {
        ApprovalsDetails: Approvals,
        NominationsEdit: Nominations,
        ReportsEdit: ReportsEditPortal,
      },
    };
  },
  computed: {
    currentPortal() {
      return this.portals[this.$route.name];
    },
  },
};
</script>
